module.exports = __webpack_public_path__ + "img/archive-files.eb437b9f.svg";